function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.372 13.053a.673.673 0 010-1.345H18.46a.673.673 0 010 1.345zm0 4.035a.673.673 0 110-1.345H18.46a.673.673 0 110 1.345zm0-8.071a.673.673 0 110-1.345H18.46a.673.673 0 010 1.345zM4 8.345A1.345 1.345 0 115.345 9.69 1.346 1.346 0 014 8.345zm.841 0a.5.5 0 10.5-.5.505.505 0 00-.5.5zM4 12.381a1.345 1.345 0 111.345 1.345A1.346 1.346 0 014 12.381zm.841 0a.5.5 0 10.5-.5.505.505 0 00-.5.5zM4 16.416a1.345 1.345 0 111.345 1.345A1.346 1.346 0 014 16.416zm.841 0a.5.5 0 10.5-.5.505.505 0 00-.5.5z",
  "data-name": "Path 491"
});

var SvgPicklist = function SvgPicklist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPicklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/picklist.318fa583.svg";
export { ForwardRef as ReactComponent };